import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useTheme } from '../theme/ThemeProvider';
import { RefreshCw } from 'lucide-react';

export default function ProtectedRoute({ children, blockFitnessOnly = false }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { t } = useTheme();

  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <RefreshCw size={24} color={t.textMuted} style={{ animation: 'spin 1s linear infinite' }} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Friends-of-the-house fitness accounts have no access to trading pages.
  if (blockFitnessOnly && user?.fitness_only) {
    return <Navigate to="/fitness" replace />;
  }

  return children;
}
